/* eslint-disable no-unused-vars */
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from 'App';
import { BASE_PATH } from 'config';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';
import { createRoot } from 'react-dom/client'; // make sure this import is correct
import 'assets/scss/style.scss';
import store from 'app/store';

const container = document.getElementById('root');
const root = createRoot(container); // replace ReactDOM.render with createRoot
root.render(
    <Provider store={store}>
        <ConfigProvider>
            <BrowserRouter basename={BASE_PATH}>
                <App />
            </BrowserRouter>
        </ConfigProvider>
    </Provider>
);
serviceWorker.unregister();

reportWebVitals();
